import { createAsyncThunk } from "@reduxjs/toolkit";
import { db } from "../../../firebase/config";
import { TalesArea } from "../../../utils/types/TalesArea";

export const editArea = createAsyncThunk(
  "aree/edit",
  async (area: TalesArea) => {
    try {
      const querySnapshot = await db
        .collection("aree")
        .where("title", "==", area.title)
        .get();

      return querySnapshot.docs[0].ref.set(area);
    } catch (e: any) {
      console.log(e);

      return Promise.reject(`Area non eliminata, ${e.message}`);
    }
  },
);
